module.exports = __webpack_public_path__ + "img/selected4-min.f53636ba.png";